<template>
  <v-app class="grey lighten-3">
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div class="white--text headline">
                <span>Project Details Report</span>
              </div>
              
            </v-card-title>
            <v-card-text>
              <template>
                <v-data-table
                  :items="indexData.project"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <v-layout class="v-navigation-drawer__content">
                      <v-flex xs12 sm12 md6>
                        <tr style="border: 1px #ddd solid">
                          <td width="30%">Project ID</td>
                          <td>:</td>
                          <td width="70%" class="text-xs-left">
                            {{ props.item.id }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td width="30%">Project Name</td>
                          <td>:</td>
                          <td width="70%" class="text-xs-left">
                            {{ props.item.name }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td>Project Created Date</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.created_at }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td>Estimated Starting Date</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.begin_date }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td>Project Type</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.project_type_name }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td>Project Language</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.project_language }}
                          </td>
                        </tr>
                      </v-flex>
                      <v-flex xs6 sm12 md6>
                        <tr style="border: 1px #ddd solid">
                          <td width="30%">Total Budget(Tk)</td>
                          <td>:</td>
                          <td width="70%" class="text-xs-left">
                            {{ props.item.total_budget_amount }}
                          </td>
                        </tr>
                        <tr
                          style="border: 1px #ddd solid"
                        >
                          <td>Total Budget(coins)</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.total_budget_coins }}
                          </td>
                        </tr>
                        <tr
                          style="border: 1px #ddd solid"
                        >
                          <td>Budget Remaining(Taka)</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ getTakaFromCoins(props.item.total_budget_coins) }}
                          </td>
                        </tr>
                        <tr
                          style="border: 1px #ddd solid"
                        >
                          <td>Budget Remaining(coins)</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.total_budget_coins }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td v-if="props.item.project_status_id >= 8">
                            Per Survey Cost(Coins)
                          </td>
                          <td v-else>Per Survey Cost(Tk)</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.per_survey_cost }}
                          </td>
                        </tr>
                        <tr style="border: 1px #ddd solid">
                          <td v-if="props.item.project_status_id >= 8">
                            Per Survey Cost(Coins)
                          </td>
                          <td v-else>Per Survey Cost(Tk)</td>
                          <td>:</td>
                          <td class="text-xs-left">
                            {{ props.item.per_survey_cost }}
                          </td>
                        </tr>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
              </template>

              <!-- start location -->
              <v-card-title class="project">
                <div class="white--text headline">
                  <span>Dasher's Info</span>
                </div>
              </v-card-title>
              <v-card-text v-if="isLoaded">
                <v-data-table
                  :headers="headers"
                  :items="indexData.dasher"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.user_id }}</td>
                    <td>{{ props.item.task_status_name }}</td>
                    <td v-if="props.item.project_location_id">Yes</td>
                    <!-- <td v-if="props.item.project_location_id">{{ props.item.project_location_id }}</td> -->
                    <td v-else>No</td>
                    <td>{{ props.item.received_coins }}</td>
                    <td>{{ props.item.received_points }}</td>
                    <td>{{ props.item.previous_points }}</td>
                    <td>{{ props.item.rank_id }}</td>
                    <td>{{ props.item.new_rank }}</td>
                    <td>{{ props.item.dasher_feedback }}</td>
                  </template>
                </v-data-table>
              </v-card-text>
              <!-- end location -->
            </v-card-text>
            <v-spacer></v-spacer>
              <v-btn class="button" color="info" flat @click="download"
                >Download</v-btn
              >
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import router from "../../../router";

export default {
  data: () => ({
    apiUrl: "project-detail-report",
    editedIndex: -1,
    dialog: false,
    projectId: "",
    transaction_status_id: "",
    paymentPercentage: "",
    projectStatus: {
      status_name: null,
      status_id: null,
    },
    paymentStatus: {
      payment_status_name: null,
      payment_status_id: null,
    },
    projectTypeId: null,
    headers: [
      { text: "Dasher Id", align: "left", value: "user_id" },
      { text: "Submission Status", align: "left", value: "task_status_name" },
      { text: "Location Service", align: "left", value: "project_location_id" },
      { text: "Coins received", sortable: false, value: "received_coins" },
      { text: "Points received", sortable: false, value: "received_points" },
      { text: "Old Points", sortable: false, value: "previous_points" },
      { text: "Previous Rank", sortable: false, value: "rank_id" },
      { text: "New Rank", value: "new_rank" },
      { text: "Comments", value: "dasher_feedback" },
    ],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLoaded() {
      if (this.indexData.dasher) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      // this.projectId = localStorage.getItem("project_details_by_id1");
      this.projectId = this.$route.params.id;
      this.$store.dispatch("getProjectReportDetails", [
        this.projectId,
        "project-detail-report",
      ]);
    },
    download(){
      // window.open(`http://local.ddbb.com/project-details-report-export/${this.projectId}`);
      window.open(this.indexData.excelUrl);
    },
    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    getTakaFromCoins(coins){
        return coins/10;
      },
    close() {
      setTimeout(() => {
        this.budget = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    getResponse(projectId) {
      // console.log(projectId)
      this.$store.dispatch("getProjectReportResponse", [
        projectId,
        "project-response",
      ]);
    },
    back() {
      router.push("/project-summary-report");
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.no-upercase {
  text-transform: unset !important;
}
.text_color {
  color: white;
}
.project {
  background: #ff2e2e;
}
::v-deep ::-webkit-scrollbar {
  width: 0;
}
</style>
